import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider }    from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import { Toaster }         from "react-hot-toast";
import Navbar              from "./components/Navbar";
import Footer              from "./components/Footer";
import Home                from "./pages/Home";
import AdminLogin          from "./admin/AdminLogin";
import AdminDashboard      from "./admin/AdminDashboard";
import ProtectedRoute      from "./admin/ProtectedRoute";

function PublicLayout() {
  return (
    <>
      <div className="star-bg" />
      <div className="grid-overlay" />
      <Navbar />
      <Home />
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "rgba(11,30,48,.95)",
                color: "#ecf5ff",
                border: "1px solid rgba(36,144,224,.3)",
                fontFamily: "'Century Gothic', sans-serif",
                fontSize: ".82rem",
              },
            }}
          />
          <Routes>
            <Route path="/"                 element={<PublicLayout />} />
            <Route path="/admin"            element={<AdminLogin />} />
            <Route path="/admin/dashboard"  element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}
